import { FlexRow } from '@fox/layout';
import { PAGE_TYPES } from '../page-types';
import { ClickHeaderLink } from './click-header-link';
import { MenuProps } from './contracts';
import { HoverHeaderLink } from './hover-header-link';

function getGapForHeaders(headerSpacing: string): string {
	switch (headerSpacing) {
		case 'Minimal':
			return '0.5rem';
		case 'Spacious':
			return '1.5rem';
		case 'Extended':
			return '2rem';
		case 'Standard':
		default:
			return '1rem';
	}
}

export function MegaMenu({ currentUrl, menuItems, maxRowsPerColumn, headerSpacing, expandOn, hideDropdownArrow }: MenuProps) {
	const maxRows = maxRowsPerColumn > 0 ? maxRowsPerColumn : 10;
	const hasClickableRootLinks = menuItems.find(menuItem => menuItem.type === PAGE_TYPES.BASIC_WITH_SUB_ITEMS) !== undefined;
	const gap = getGapForHeaders(headerSpacing);
	return (
		<FlexRow style={{ alignItems: 'center', height: '100%', gap: gap }}>
			{menuItems?.map(menuItem => {
				return hasClickableRootLinks || expandOn === 'Hover' ? (
					<HoverHeaderLink
						key={menuItem.id}
						menuItem={menuItem}
						maxRowsPerColumn={maxRows}
						currentUrl={currentUrl}
						isMegaMenu={menuItem.megaMenu}
						hideDropdownArrow={hideDropdownArrow}
					/>
				) : (
					<ClickHeaderLink
						key={menuItem.id}
						menuItem={menuItem}
						maxRowsPerColumn={maxRows}
						currentUrl={currentUrl}
						isMegaMenu={menuItem.megaMenu}
						hideDropdownArrow={hideDropdownArrow}
					/>
				);
			})}
		</FlexRow>
	);
}
